function cleanEnvUrl(value: string): string {
  return value
    .replace(/^["']|["']$/g, '')
    .replace(/\\"/g, '')
    .replace(/\\'/g, '')
    .replace(/\\\\/g, '')
    .trim();
}

function ensureHttpProtocol(url: string): string {
  if (/^https?:\/\//i.test(url)) return url;
  return `http://${url}`;
}

function stripApiSuffix(url: string): string {
  return url
    .replace(/\/(api\/v1)\/?$/i, '')
    .replace(/\/(api)\/?$/i, '');
}

export function getBackendOrigin(): string {
  const raw = import.meta.env.VITE_BACKEND_URL || '';
  const cleaned = cleanEnvUrl(raw);

  const fallback = import.meta.env.PROD
    ? 'https://twillo-estrabilio-staging.optimusai.ai'
    : 'http://localhost:8080';

  if (!cleaned) return fallback;

  const withProtocol = ensureHttpProtocol(cleaned);
  return stripApiSuffix(withProtocol).replace(/\/$/, '');
}

export function getSocketIoPath(): string {
  const raw = import.meta.env.VITE_SOCKET_IO_PATH || '';
  const cleaned = cleanEnvUrl(raw);
  return cleaned || '/socket.io';
}

export function getActiveCallsNamespace(): string {
  const raw = import.meta.env.VITE_ACTIVE_CALLS_NAMESPACE || '';
  const cleaned = cleanEnvUrl(raw);
  // Active calls frequently lives on the default namespace; allow override via env.
  // Use '' (root) by default to match the working Transcript socket.
  if (!cleaned || cleaned === '/') return '';
  return cleaned.startsWith('/') ? cleaned : `/${cleaned}`;
}
